import { render, staticRenderFns } from "./CopyTrigger.vue?vue&type=template&id=4e0ce085&"
import script from "./CopyTrigger.vue?vue&type=script&lang=js&"
export * from "./CopyTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports